module.exports = __webpack_public_path__ + "static/media/Master-3.ad410dd7.webp";